import { render, staticRenderFns } from "./WidgetLoadMore.vue?vue&type=template&id=3ff2231c&"
import script from "./WidgetLoadMore.vue?vue&type=script&lang=js&"
export * from "./WidgetLoadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports